// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'wp-block-table';
const dataTdAttr = 'data-table-head';
const tableBreakpoint = '767px';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class tableMobile {
  constructor(el) {
    this.el = el;
    this.$table = $(el).find('table');
    this.$tbody = $(el).find('tbody');
    this.$tableHead = $(el).find('thead');
    this.$tbodyTr = $(el).find('tbody tr');
    // this.$button = $(el).find('button');

    this.mediaMatcher = window.matchMedia(`(max-width: ${tableBreakpoint})`);

    this.fillTbodyAttr();
  }

  fillTbodyAttr() {
    if (this.$tableHead.length === 0) return;

    for (const itemTr of this.$tbodyTr) {
      let index = 1;

      for (const itemTd of itemTr.querySelectorAll('td')) {
        const getHeadText = this.$tableHead.find(`th:nth-child(${index})`).text();
        itemTd.setAttribute(dataTdAttr, getHeadText);
        index++
      }
    }
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new tableMobile(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
